import styled from 'styled-components';
import Budget from '../../../types/TeamCalculator/Budget';

export const Wrapper = styled.div`
  position: relative;

  & > div {
    form {
      display: flex;
      flex-direction: column;
    }
  }
`;

export const BudgetsWrapper = styled.div`
  h2 {
    font-weight: 500;
  }
  padding: 0 26px;
  padding-bottom: 26px;

  a {
    text-decoration: none !important;
  }
`;

export const BudgetActionsStyled = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 26px;
  padding-bottom: 26px;
  gap: 10px;
  select {
    max-width: 300px;
  }

  & > div {
    display: flex;
    gap: 20px;
  }
`;

export const Divider = styled.div`
  width: 100%;
  border-top-style: solid;
  border-top-width: 1px;
  border-top-color: #9a9a9a;
  margin: 10px 0;
`;

export const BudgetDescriptionStyled = styled.div`
  width: 100% !important;

  div {
    display: flex;
    justify-content: space-between;
    gap: 4px;
  }

  .description-column {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: flex-start;
  }

  .description-item {
    display: flex;
    flex-direction: row;
    text-align: left;
    align-items: center;
  }

  .description-label {
    font-weight: 600 !important;
  }

  select {
    margin-left: 5px;
    width: 120px;
    min-height: unset !important;
    height: 30px;
    font-size: 12px;
    padding: 0;
    font-size: 14px;
    color: #6a6a6a !important;
    font-weight: 600 !important;
    border-color: #ddd;
  }

  .description-value {
    margin-left: 5px;
    button {
      height: 28px !important;
      width: 28px !important;
      margin-left: 5px;
      padding: 0;
      background-color: ${(props) => props.theme.colors.blue};
    }
    input {
      box-sizing: border-box;
      padding: 0 5px;
      width: 120px;
      font-size: 12px;
      height: 28px !important;
      min-height: 28px !important;
    }
  }

  .status-container {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
  }
`;

export const AcceptedBanner = styled.div<{ status?: Budget['status'] }>`
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 5px;
  color: white;
  font-size: 10px;
  background-color: ${(props) =>
    props.status === 'declined'
      ? props.theme.colors.red
      : props.status === 'accepted'
        ? props.theme.colors.green
        : props.theme.colors.darkGray};
  border-radius: 4px;
`;
